module.exports = __webpack_public_path__ + "a11188cd0c3c94754586b7f0c16ee48e.svg";